var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "20px",
    viewBox: "0 0 9 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 27") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Landing-page-&-Service-page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "page-5",
    transform: "translate(-324.000000, -727.000000)",
    fill: "#FFFFFE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.042565,747 L329.968359,747 L329.968359,736.914805 L332.708447,736.914805 L333,733.538294 L329.968359,733.538294 C329.968359,733.538294 329.968359,732.277754 329.968359,731.615318 C329.968359,730.819004 330.125153,730.504303 330.875224,730.504303 C331.47867,730.504303 333,730.504303 333,730.504303 L333,727 C333,727 330.759959,727 330.2811,727 C327.359638,727 326.042565,728.319656 326.042565,730.845953 C326.042565,733.046249 326.042565,733.538294 326.042565,733.538294 L324,733.538294 L324,736.957402 L326.042565,736.957402 L326.042565,747",
    id: "Fill-27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialFacebook);
export default __webpack_public_path__ + "static/media/social-facebook.142bcfa470c66b53b92d6eb5269701b0.svg";
export { ForwardRef as ReactComponent };